export const browserNotificationSettings = {
  chat: false,
};

export async function requestChatBrowserNotificationPermission(): Promise<NotificationPermission> {
  if (typeof Notification === "undefined") return "denied";
  if (Notification.permission !== "default") return Notification.permission;
  return Notification.requestPermission();
}

export function maybeDisplayBrowserNotification(
  title: string,
  body: string
): void {
  if (!browserNotificationSettings.chat) return;
  if (typeof Notification === "undefined") return;
  if (Notification.permission !== "granted") return;
  if (typeof document !== "undefined" && !document.hidden) return;
  const options = { body, icon: "/assets/images/logo.svg" };
  try {
    const n = new Notification(title, options);
    n.onclick = () => {
      window.focus();
      n.close();
    };
  } catch {
    navigator.serviceWorker?.ready.then((reg) =>
      reg.showNotification(title, options)
    );
  }
}
